import { PROGRAM_IDS } from '../../utils/constants'
import { ProgramConfig } from '../../types/apiModels'

export const DAP_FORMULAS = {
  [PROGRAM_IDS.RETERRA]: {
    label: 'Fórmula: (Volumen muestra - Peso grava) / (Volumen muestra - (Peso grava / 2.65))',
    formula: ({ sampleVolume, gravelWeight }: { sampleVolume: number; gravelWeight: number }) =>
      (sampleVolume - gravelWeight) / (sampleVolume - gravelWeight / 2.65),
    gravelVolumeRequired: false,
  },
  [PROGRAM_IDS.SARA]: {
    label: 'Fórmula: (Peso seco - Peso grava) / (Volumen muestra - Volumen grava)',
    formula: ({
      dryWeight,
      gravelWeight,
      sampleVolume,
      gravelVolume,
    }: {
      dryWeight: number
      gravelWeight: number
      sampleVolume: number
      gravelVolume: number
    }) => (dryWeight - gravelWeight) / (sampleVolume - gravelVolume),
    gravelVolumeRequired: true,
  },
  [PROGRAM_IDS.POA]: {
    label: 'Fórmula: (Peso seco - Peso grava) / (Volumen muestra - Volumen grava)',
    formula: ({
      dryWeight,
      gravelWeight,
      sampleVolume,
      gravelVolume,
    }: {
      dryWeight: number
      gravelWeight: number
      sampleVolume: number
      gravelVolume: number
    }) => (dryWeight - gravelWeight) / (sampleVolume - gravelVolume),
    gravelVolumeRequired: true,
  },
}

export const calculateDAP = (row: any, programConfig: ProgramConfig) => {
  const dryWeight = parseFloat(row.dryWeight) || 0
  const gravelWeight = parseFloat(row.gravelWeight) || 0
  const sampleVolume = parseFloat(row.sampleVolume) || 0
  const gravelVolume = parseFloat(row.gravelVolume) || 0

  if (dryWeight <= 0 || sampleVolume <= 0) {
    return null
  }

  const programId = programConfig?.programId

  const formula = DAP_FORMULAS[programId]?.formula

  if (!formula) {
    return null
  }

  return formula({ dryWeight, gravelWeight, sampleVolume, gravelVolume }) || null
}
